import { intersection } from "lodash";
import {
  CreatedArtifactFragmentFragment,
  GetMeetingGoalsNewPageQueryQueryVariables,
  GetMeetingRecognitionsNewPageQueryQueryVariables,
} from "types/graphql-schema";

import { refetchActionItemsInCollapsibleContainers } from "@apps/action-items-collapsible/helpers";
import getDashboardGoalsQuery from "@apps/dashboard-new/graphql/get-dashboard-goals-query";
import getMeetingGoalsQuery from "@apps/meeting-new/graphql/get-meeting-goals-query";
import getMeetingRecognitionsQuery from "@apps/meeting-new/graphql/get-meeting-recognitions-query";
import { getWatchedQueries } from "@graphql/client";

export const updateArtifactsCacheWithCreatedArtifact = (
  createdArtifact: CreatedArtifactFragmentFragment
) => {
  // Refresh watched queries
  if (createdArtifact.__typename === "ActionItemArtifactNode") {
    refetchActionItemsInCollapsibleContainers(createdArtifact);
  }

  if (createdArtifact.__typename === "GoalArtifactNode") {
    const watchedQueries = getWatchedQueries(getDashboardGoalsQuery);
    watchedQueries.forEach((watchedQuery) => {
      const watchedQueryVariables = watchedQuery.options
        .variables as GetMeetingGoalsNewPageQueryQueryVariables;
      if (
        watchedQueryVariables.goalScopes &&
        watchedQueryVariables.goalScopes.includes(createdArtifact.scope)
      ) {
        const size = (
          watchedQuery.getCurrentResult().data?.goalsForUser.edges || []
        ).length;
        const variables = {
          ...watchedQueryVariables,
          after: null,
          first: size + 1,
        };
        watchedQuery.fetchMore({ variables });
      }
    });
  }
  if (createdArtifact.__typename === "GoalArtifactNode") {
    const watchedQueries = getWatchedQueries(getMeetingGoalsQuery);
    watchedQueries.forEach((watchedQuery) => {
      const watchedQueryVariables = watchedQuery.options
        .variables as GetMeetingGoalsNewPageQueryQueryVariables;
      if (watchedQueryVariables.goalState === createdArtifact.goalState) {
        const size = (
          watchedQuery.getCurrentResult().data?.artifacts.edges || []
        ).length;
        const variables = {
          ...watchedQueryVariables,
          after: null,
          first: size + 1,
        };
        watchedQuery.fetchMore({ variables });
      }
    });
  }
  if (createdArtifact.__typename === "RecognitionArtifactNode") {
    const recipientIds =
      createdArtifact.recipients?.edges.map((edge) => edge?.node?.id) || [];
    const watchedQueries = getWatchedQueries(getMeetingRecognitionsQuery);
    watchedQueries.forEach((watchedQuery) => {
      const watchedQueryVariables = watchedQuery.options
        .variables as GetMeetingRecognitionsNewPageQueryQueryVariables;
      if (
        (createdArtifact.creator?.id &&
          Array.isArray(watchedQueryVariables.createdByIds) &&
          watchedQueryVariables.createdByIds.includes(
            createdArtifact.creator.id
          )) ||
        (Array.isArray(watchedQueryVariables.recognitionRecipients) &&
          intersection(
            watchedQueryVariables.recognitionRecipients || [],
            recipientIds
          ).length > 0)
      ) {
        const size = (
          watchedQuery.getCurrentResult().data?.artifacts.edges || []
        ).length;
        const variables = {
          ...watchedQueryVariables,
          after: null,
          first: size + 1,
        };
        watchedQuery.fetchMore({ variables });
      }
    });
  }
};
